<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
  <path fill="#fff" fill-rule="evenodd" d="M7 26.143h5.313V39h23.374V26.143H41L24 9 7 26.143z" clip-rule="evenodd"/>
  <path stroke="#000" stroke-width="2" d="M7 26.143h5.313V39h23.374V26.143H41L24 9 7 26.143z" clip-rule="evenodd"/>
  <path stroke="#000" stroke-width="2" d="M20 26v13h8V26h-8z" clip-rule="evenodd"/>
</svg>
